import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2dve4egfbx: FaireBrandEntity = {
  token: "b_2dve4egfbx",
  type: "brand",
  name: "The Shoppe at Little Creek",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb9f49c940af1354e83bdbea8489ff9f490948f295863d5270c9b4cc8b200633.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/64861e915db0e252b3c8da4383cf3d0633d8122cba8c80fee9487f347defbb78.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eb9f49c940af1354e83bdbea8489ff9f490948f295863d5270c9b4cc8b200633.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/64861e915db0e252b3c8da4383cf3d0633d8122cba8c80fee9487f347defbb78.jpeg",
  location: "Clayton, NC, USA",
  minimumOrderDollars: 195,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "My name is Melissa Allen, I would love to share my story with you!\nMy husband and I run our small business from our home as we care for our two small children. We thrive on creating learning tools that children can enjoy. We focus on providing fun, safe, learning guides for all ages. \nWe strive for perfection and would love to share our products with you.   ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:35.379Z",
    importedBy: "entity-db-cli",
  },
};
